module.exports = __webpack_public_path__ + "static/img/economy-banner-bg.276264c0.png";